import { useContext } from 'react';

import AnalyticsMetaContext, { type AnalyticsMetaCtx } from './context';

const useAnalyticsMeta = (): AnalyticsMetaCtx => useContext(AnalyticsMetaContext);

export default useAnalyticsMeta;
